__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-page-wrapper'].baseUrl;
import PageWrapper from './components/PageWrapper';
export default PageWrapper;
;
if (!global.BROWSER) {
  PageWrapper.appConfig = Object.assign({}, PageWrapper.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  PageWrapper.appConfig = Object.assign({}, PageWrapper.appConfig, {
    requiredExternals: {
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      '@americanexpress/travel-selectors': '^5.0.0',
      '@americanexpress/one-experiments': '^2.1.5'
    }
  });
}